import {LitElement, css, html} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
// import {msg, localized} from '@lit/localize';

//@localized()
@customElement('artist-search')
export class ArtistSearch extends LitElement {

  @state()
  _debounce:number = 0;

  @property()
  searchTerm = '';

  @property()
  placeholder = '';

  private _onInput(e: Event) {
    clearTimeout(this._debounce)
    this.searchTerm = (e.target as HTMLInputElement).value;
    const options = {
      detail: this.searchTerm,
      bubbles: true,
      composed: true
    };

    const _this = this
    this._debounce = window.setTimeout(function () {
      _this.dispatchEvent(new CustomEvent('artistSearchChange', options));
    }, 300)

  }


  render() {
    return html`
      <input part="search" 
             class="search" 
             type="search" 
             placeholder="${this.placeholder}" 
             .value=${this.searchTerm}
             @input=${this._onInput}
      />
    `;
  }

  static styles = css`
      :host {
          font-size: inherit;
          font-family: inherit;
          display: block;
          scroll-margin: 5rem;
      }
      .search {
          display: block;
          width: 100%;
          padding: 0.5em 1em;
          border-radius: 3em;
          font-size: inherit;
          font-family: inherit;
      }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'artist-search': ArtistSearch
  }
}
